<script setup lang="ts">
defineProps({
    eyebrow: {
        type: String,
        default: '',
    },
    title: {
        type: String,
        required: true,
    },
    buttonLabel: {
        type: String,
        required: false,
    },
    buttonLink: {
        type: String,
        required: false,
    },
    buttonIcon: {
        type: String,
        required: false,
    },
})
</script>

<template>
    <section class="py-9 bg-chsc-raw">
        <UiContainer
            :max-width="'max-w-full'"
            class="px-9"
        >
            <p
                v-if="eyebrow"
                class="font-montserrat fs-xl text-chsc-indigo-500"
            >
                {{ eyebrow }}
            </p>
            <h1 class="-mt-2 font-londrina-solid fs-7xl font-bold uppercase text-chsc-indigo-500">
                {{ title }}
            </h1>
            <UButton
                v-if="buttonLabel && buttonLink"
                :label="buttonLabel"
                :icon="buttonIcon"
                variant="outline"
                size="xs"
                class="mt-3"
                :to="buttonLink"
            />
        </UiContainer>
    </section>
</template>
